export const getOfferText = (offersCount: number) => {
  switch (offersCount) {
    case 1:
      return 'предложение';
    case 2:
    case 3:
    case 4:
      return 'предложения';
    default:
      return 'предложений';
  }
};
